import React from "react";
import { Calendar } from "primereact/calendar";
import { useTranslation } from "react-i18next";

const InputCalendar = (props) => {
  const {
    input,
    placeholder,
    label,
    asterisk,
    disabled,
    meta: { touched, error },
  } = props;
  const { t } = useTranslation("master");
  const handleChange = (e) => {
    input.onChange(e.value);
  };
  return (
    <>
      <label className="input-label">
        <span className="astoricstyle">{asterisk}</span>
        {t(label)}
      </label>
      <Calendar
        value={input.value || null}
        placeholder={placeholder}
        disabled={disabled}
        onChange={handleChange}
        dateFormat="dd/mm/yy"
        className={
          touched && error
            ? "input-style p-inputtext border-red-500"
            : "input-style p-inputtext"
        }
      />
      {touched && error && <span className="text-red-500">{error}</span>}
    </>
  );
};

export default InputCalendar;
